import React, { useState } from "react";
import HeaderContent from "./HeaderContent";
import HeaderMenu from "./HeaderMenu";

const Header = ({ openModal }) => {
    const [isOpenMenu, setIsOpenMenu] = useState(false);

    function openMenuHandle() {
        setIsOpenMenu((prevState) => !prevState);
    }

    return (
        <div className="header">
            <HeaderContent isOpenMenu={isOpenMenu} openModal={openModal} openMenu={openMenuHandle} />

            <div className={isOpenMenu ? "menu-open" : "menu-close"}>
                <HeaderMenu openMenu={openMenuHandle} />
            </div>
        </div>
    );
};

export default Header;
